export const CLIENT_TYPE_OPTIONS = [

  {

    value: "person",

    label: "Persona"

  },

  {

    value: "company",

    label: "Empresa"

  }

];